import { render, staticRenderFns } from "./IntegrationAI.vue?vue&type=template&id=24b89b81&scoped=true"
import script from "./IntegrationAI.vue?vue&type=script&lang=js"
export * from "./IntegrationAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b89b81",
  null
  
)

export default component.exports